import type { ComponentProps, ReactNode } from 'react'
import { useRef } from 'react'
import { Button } from '~/components/ui/button'

type Props = Omit<ComponentProps<typeof Button>, 'onChange' | 'onClick' | 'type' | 'asChild'> & {
  accept: string
  /** Le fichier choisi. Le champ est vidé ensuite : rechoisir le même fichier relance l'import. */
  onFile: (file: File) => void
  children: ReactNode
}

/**
 * Bouton qui ouvre le sélecteur de fichier (RGAA 7.3). Un `<label>` habillé en
 * bouton n'entre jamais dans l'ordre de tabulation : l'import était impossible
 * au clavier. Ici le déclencheur est un vrai bouton, l'input reste caché.
 */
function FilePickerButton({ accept, onFile, children, variant = 'outline', size = 'sm', ...button }: Props) {
  const input = useRef<HTMLInputElement>(null)
  return (
    <>
      <input
        ref={input}
        type="file"
        accept={accept}
        className="hidden"
        tabIndex={-1}
        aria-hidden
        onChange={(event) => {
          const file = event.target.files?.[0]
          event.target.value = ''
          if (file) onFile(file)
        }}
      />
      <Button {...button} type="button" variant={variant} size={size} onClick={() => input.current?.click()}>
        {children}
      </Button>
    </>
  )
}

export default FilePickerButton
